import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class pastEvents extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
  {/* breadcrumb-area */}
  <div
    className="breadcrumb__area breadcrumb__bg"
    data-background="assets/img/aboutUs_img.jpg"
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="breadcrumb__content">
            {/* <h2 class="title">About Us</h2> */}
            <nav className="breadcrumb">
              <span property="itemListElement" typeof="ListItem">
                <a href="index.html">Home</a>
              </span>
              <span className="breadcrumb-separator">/</span>
              <span property="itemListElement" typeof="ListItem">
                Exhibitors
              </span>
              <span className="breadcrumb-separator">/</span>
              <span
                className="beadcrumb-active"
                property="itemListElement"
                typeof="ListItem"
              >
                Past Events
              </span>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* breadcrumb-area-end */}
  {/* about-area */}
  <section className="Past_Events_section">
    <div className="container">
      <div className="row" data-aos="fade-up" data-aos-delay={300}>
        <div className="col-md-12 text-center">
          {/* <h4 class="border_title">Events</h4> */}
          <div className="selector">
            <h2 className="ah-headline letters rotate-3">
              {/* <p>Conference Organisation</p> */}
              <span className="position_relative yellow_color">
                Past Events
              </span>
            </h2>
          </div>
        </div>
      </div>
      <div className="row mt_40">
        <div className="col-md-12">
          <div className="PastEvents_grid_View">
            <div className="main_div">
              <img src="assets/img/Past_events/itme-2023.jpeg" />
              <div className="content_div">
                <p className="mb_0">ITME Africa &amp; Middle East 2023</p>
                <div className="btn_div">
                  <a
                    href="https://www.itme-africa.com/flipbook/post-event-report-2023/"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Post Show Report
                  </a>
                  <a
                    href="exhibitors-list.html"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Exhibitor List
                  </a>
                </div>
              </div>
            </div>
            <div className="main_div">
              <img src="assets/img/Past_events/itme-2022.jpg" />
              <div className="content_div">
                <p className="mb_0">ITME 2022</p>
                <div className="btn_div">
                  <a
                    href="https://itme2022.india-itme.com/post-report-itme-2022/India-ITME-2022-Post-Event-Report.html"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Post Show Report
                  </a>
                  <a
                    href="exhibitors-list.html"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Exhibitor List
                  </a>
                </div>
              </div>
            </div>
            <div className="main_div">
              <img src="assets/img/Past_events/gttes-2019.jpg" />
              <div className="content_div">
                <p className="mb_0">GTTES 2019</p>
                <div className="btn_div">
                  <a
                    href="https://corporate.india-itme.com/gttes2025/GTTES_2019_Report/mobile/index.html"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Post Show Report
                  </a>
                  <a
                    href="exhibitors-list.html"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Exhibitor List
                  </a>
                </div>
              </div>
            </div>
            <div className="main_div">
              <img src="assets/img/Past_events/gttes-2015.jpg" />
              <div className="content_div">
                <p className="mb_0">GTTES 2015</p>
                <div className="btn_div">
                  <a
                    href="https://corporate.india-itme.com/gttes2025/wp-content/themes/gttes/pdf/gttes_2015_post_event_report.pdf"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Post Show Report
                  </a>
                  <a
                    href="exhibitors-list.html"
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Exhibitor List
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(pastEvents));